import Loader from "react-loaders";
import React from "react";

const Preloader = () => {
    return (
        <div className="preloading-center">
            <div className="loader-container-inner">
                <div className="text-center preloading-center">
                    <Loader type="line-scale-party"/>
                    <h6 className="mt-3 text-center">
                        Launching 1MessageApp
                        <div className="text-center">
                            <small>The power of emerging tech is working for You!</small>
                        </div>
                    </h6>
                </div>

            </div>
        </div>
    )
};

export default Preloader
